// Calculates the source popover position.

export interface SourceAnchor {
  index: number;
  x: number;
  y: number;
}

const POPOVER_HALF_WIDTH = 210;

export function sourceAnchorFor(card: HTMLElement | null, target: HTMLElement, index: number): SourceAnchor {
  if (!card) return { index, x: POPOVER_HALF_WIDTH, y: 0 };
  const cardRect = card.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const rawX = targetRect.left + targetRect.width / 2 - cardRect.left;
  const maxX = Math.max(POPOVER_HALF_WIDTH, cardRect.width - POPOVER_HALF_WIDTH);
  return { index, x: Math.min(Math.max(rawX, POPOVER_HALF_WIDTH), maxX), y: targetRect.top - cardRect.top };
}
